// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"

// import * as bootstrap from "bootstrap";
import 'bootstrap/dist/js/bootstrap'
import "./controllers"
import './src/jquery'
